import { ReduxStore } from 'store/types';

function getSearchedInterventionIsLoading(state: ReduxStore): boolean {
  return state.intervention.getSearchedIntervention.config.isLoading;
}

export default getSearchedInterventionIsLoading;
